export class GetPaymentSummaryCounters {
  static readonly type = '[Account] GetPaymentSummaryCounters';
  constructor(public queryParams: string[]) {}
}
